import { useContext, useEffect, useReducer, useState } from "react";
import { Store } from "../Store";
import { getError } from "../utils";
import useAxios from "./useAxios";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default function useUsers() {
  const axios = useAxios();
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { userInfo, users } = state;
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const [loadUsers, setLoadUsers] = useState(false);

  const fetchUsers = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });
      const { data } = await axios.get(`/api/busers`);

      dispatch({ type: "FETCH_SUCCESS", payload: data });
      ctxDispatch({
        type: "USERS_UPDATED",
        payload: data || [],
      });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  useEffect(() => {
    if (userInfo && !users) {
      fetchUsers();
    }
  }, [userInfo]);

  useEffect(() => {
    if (loadUsers) {
      fetchUsers();
      setLoadUsers(false);
    }
  }, [loadUsers]);

  return [loading, error, setLoadUsers];
}
